
import React, { useEffect, useState, useCallback } from "react";
import { getRequestInAssets as getRequestOnEnterprise ,deleteRequestInAssets} from "services/axiosAssetsBaseClient";
import TableAndSearch from "../common/TableAndSearch";
import { useHistory } from "react-router-dom";
import LocalStorageService from "services/tokenlocalstorage.service";
import { NotificationManager } from "react-notifications";

var tableSearchKey;
var tempSearch;

export default function BatteryList(props) {
  const { headerFilter } = props;

  const history = useHistory();

  const [batteryHeaderFilterData, setBatteryHeaderFilterData] = useState([]);
  const [makeSearch, setMakeSearch] = useState([]);
  const [search, setSearch] = useState("");
  const [totalCount, setTotalCount] = useState(0);

  const batteryHeaderFilterHandle = (searchString) => {
    if (
      typeof searchString === "object" ||
      typeof searchString === "undefined" ||
      (typeof searchString === "string" && searchString?.trim().length === 0)
    ) {
    } else {
      localStorage.setItem("lastTableSearch", searchString);
    }

    const headerFilterObj = JSON.parse(LocalStorageService.get("headerFilter"));
    var query =
      // (headerFilterObj?.enterprise
      //   ? "enterprise=" + headerFilterObj.enterprise
      //   : "") +
      (headerFilterObj?.stateId ? "&stateId=" + headerFilterObj?.stateId : "") +
      (headerFilterObj?.cityId ? "&cityId=" + headerFilterObj?.cityId : "") +
      // (headerFilterObj?.zoneId ? "&zoneId=" + headerFilterObj?.zoneId : "") +
      (typeof searchString === "object" ||
      typeof searchString === "undefined" ||
      (typeof searchString === "string" && searchString?.trim().length === 0)
        ? ""
        : "&filter=" + encodeURIComponent(searchString));

    query = query ? "?" + query : "";

    try {
      getRequestOnEnterprise("bss/getAllBatteryDetails" + query)
        .then((res) => {
          if (res && res?.data && res?.data?.battery) {
            setBatteryHeaderFilterData(res?.data?.battery);
            props.assetCount(() => res?.data?.battery.length);
            setTotalCount(res?.data?.batteryCount);
          }
        })
        .catch((e) => {
          console.log(e, "ERROR");
        });
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    const headerFilterObj = JSON.parse(LocalStorageService.get("headerFilter"));
    tempSearch = localStorage.getItem("lastTableSearch");
    if (headerFilterObj && Object.keys(headerFilterObj).length > 0) {
      batteryHeaderFilterHandle(tempSearch.trim());
    }
    if (headerFilterObj && !headerFilterObj) {
      headerFilter = false;
      setBatteryHeaderFilterData([]);
      batteryHeaderFilterHandle(tempSearch.trim());
      // searchingByName();
    }
  }, [headerFilter]);

  useEffect(() => {
    tempSearch = localStorage.getItem("lastTableSearch");
    if (tempSearch === null) {
      tempSearch = localStorage.setItem("lastTableSearch", "");
      batteryHeaderFilterHandle();
    } else {
      batteryHeaderFilterHandle(tempSearch.trim());
    }
    window.scrollTo(0, 0);
  }, []);

  const view = (id, enterpriseName) => {
    // + `/${enterpriseName}`
    history.push("/Assets/ViewBattery/" + id + "/view" );
  };

  const update = (id, enterpriseName) => {
    history.push("/Assets/UpdateBattery/" + id );
  };

  const siteStatusHandle = (cellData, status, enterpriseName) => {
    // statusActive(cellData.cell.original,enterpriseName)
  };

  function deleteCheckBoxData(selectedRows) {
    deleteSwapStationHandle(selectedRows);
  }
  const deleteSwapStationHandle = useCallback(async (data) => {
    const ids = data.map(item => item.id);
    await deleteRequestInAssets(
      `bss/battery/softDeleteBattery?ids=${ids.join(',')}`
    ).then((res) => {
      if (res && res?.data) {
        NotificationManager.success(res?.data.message);
        batteryHeaderFilterHandle();
      }
    });
  });
 
  const columns = React.useMemo(
    () => [
      {
        Header: "Battery ID",
        accessor: "batterySerialNumber",
      },
      {
        Header: "Enterprise Name",
        accessor: "enterprise",
      },
      {
        Header: "Make",
        accessor: "make",
      },
      {
        Header: "Model",
        accessor: "model",
      },
      {
        Header: "Status",
        accessor: "status",
        Cell: (row) => {
          return (
            <>
              {row?.row?.original?.status == "COMMISSIONED" ? (
                <p
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    cursor: "default",
                    background: "#1A873C",
                    border: "1px",
                    width: "130px",
                    color: "#fff",
                    borderRadius: "5px",
                    margin: "3px 0px 2px 2px",
                    padding: "3px 0px",
                  }}
                >
                  <span style={{ margin: "0px" }}>Commissioned</span>
                </p>
              ) : row?.row?.original?.status == "DECOMMISSIONED" ? (
                <p
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    cursor: "default",
                    background: "#C71abc",
                    border: "1px",
                    width: "130px",
                    color: "#fff",
                    borderRadius: "5px",
                    margin: "3px 0px 2px 2px",
                    padding: "3px 0px",
                  }}
                >
                  <span style={{ margin: "0px" }}>DeCommissioned</span>
                </p>
              ) : row?.row?.original?.status == "PRECOMMISSIONED" ? (
                <p
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    cursor: "default",
                    background: "#C71720",
                    border: "1px",
                    width: "130px",
                    color: "#fff",
                    borderRadius: "5px",
                    margin: "3px 0px 2px 2px",
                    padding: "3px 0px",
                  }}
                >
                  <span style={{ margin: "0px" }}>PreCommissioned</span>
                </p>
              ) : (
                ""
              )}
            </>
          );
          // return (
          //   <>
          //     <div>
          //       <button style={{background:"green", border:'0px'}} >Commissioned</button>

          //     </div>
          //   </>
          // );
        },
      },
      {
        Header: " Date",
        accessor: "warrantyStartDate",
        Cell: (row) => {
          const dateObject = new Date(row.value);
          const day = dateObject.getDate();
          const month = dateObject.getMonth() + 1; 
          const year = dateObject.getFullYear();
          const formattedDay = day < 10 ? `0${day}` : day;
          const formattedMonth = month < 10 ? `0${month}` : month;
          const formattedDate = `${formattedDay}-${formattedMonth}-${year}`;
          return <span>{formattedDate}</span>;
        },
      },
      {
        Header: "Action",
        accessor: "id",
        disableSortBy: true,
        Cell: (cell) => {
          return (
            <>
              <div>
                <img
                  src={require("assets/eye.png").default}
                  style={{ margin: "8px", cursor: "pointer" }}
                  onClick={() => view(cell.value, cell.row.original.enterprise)}
                ></img>
                <img
                  src={require("assets/pencil.png").default}
                  style={{ cursor: "pointer" }}
                  onClick={() =>
                    update(cell.value, cell.row.original.enterprise)
                  }
                ></img>
                {/* {cell.row.original.isActive ? (
                      <button
                        onClick={() =>
                          siteStatusHandle(
                            cell,
                            "active",
                            cell.row.original.enterpriseName
                          )
                        }
                        style={{ border: "none", margin: "8px", cursor: "pointer" }}
                      >
                        <img src={require("assets/active.png").default} height={"20px"} width={"20px"}></img>
                      </button>
                    ) : (
                      <button
                        onClick={() =>
                          siteStatusHandle(
                            cell,
                            "inactive",
                            cell.row.original.enterpriseName
                          )
                        }
                        style={{ border: "none", margin: "8px", cursor: "pointer" }}
                      >
                        <img
                          src={require("assets/inactive.png").default}
                          height={"20px"} width={"20px"}
                         
                          // onClick={() =>
                          //   view(row.value, row.row.original.enterprise)
                          // }
                        ></img>
                      </button>
                    )} */}
              </div>
            </>
          );
        },
      },
    ],
    [batteryHeaderFilterData]
  );
  return (
    <div>
      <TableAndSearch
        totalCount= {totalCount}
        searchOpts={{
          onSearch: batteryHeaderFilterHandle,
          placeholder: "Search By Battery Id",
          setSearch: setSearch,
        }}
        columns={columns}
        data={batteryHeaderFilterData}
        // data={batteryHeaderFilterData}
        tigger={props?.tigger}
        tabTemp={props.tabTemp}
        tempSearch={tempSearch}
        headerFilterParms={headerFilter}
        isCheckBox={true}
        selectedData={deleteCheckBoxData}
      />
    </div>
  );
}

BatteryList.inStorybook = true;
